const components = Vue => {

  // Layout
  Vue.component('app', () => import('@/components/layout/app.vue'))
  Vue.component('app-header', () => import('@/components/layout/app-header.vue'))
  Vue.component('sidebar', () => import('@/components/layout/sidebar.vue'))
  Vue.component('fast-order', () => import('@/components/layout/fast-order.vue'))
  Vue.component('cookie', () => import('@/components/layout/cookie.vue'))
  Vue.component('city-selector', () => import('@/components/layout/city-selector.vue'))
}
export default components
